import { ReactNode } from 'react';

interface TitleProps {
  children: ReactNode;
  className?: string;
}

const Title = ({ children, className = '' }: TitleProps) => {
  return (
    <div className={className} data-testid="cta-subnav-title">
      {children}
    </div>
  );
};

export default Title;
